import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "integration-configs" };
const _hoisted_2 = { class: "data-table__value-text" };
const _hoisted_3 = {
    key: 0,
    class: "integration-configs__icon"
};
const _hoisted_4 = ["src"];
import { onMounted, ref } from 'vue';
import events from "@astina/paloma-common-ui/src/services/EventBus";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import shopIntegrationsRepository from '../services/ShopIntegrationsRepository';
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'IntegrationConfigsView',
    setup(__props) {
        const router = useRouter();
        const source = shopIntegrationsRepository.getGridItemsSource();
        const grid = ref(null);
        const searchRequest = ref({
            query: null,
            filters: [],
        });
        onMounted(() => {
            shopIntegrationsRepository.getGridConfig()
                .then((g) => {
                grid.value = g;
            });
        });
        function activateItem(item) {
            router.push({ name: 'integration_config_details', params: { name: item.id } }).catch(() => {
            });
        }
        function closeView() {
            router.push({ name: 'integration_config' });
        }
        function prevItem() {
            events.$emit('integration-configs.nav-prev');
        }
        function nextItem() {
            events.$emit('integration-configs.nav-next');
        }
        return (_ctx, _cache) => {
            const _component_badge = _resolveComponent("badge");
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (grid.value && _ctx.$isGranted('PORTAL_INTEGRATIONS_SETTINGS'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(DataTable, {
                            name: "integration-configs",
                            title: _ctx.$t('nav.integration'),
                            "search-request": searchRequest.value,
                            grid: grid.value,
                            source: _unref(source),
                            onActivateItem: activateItem
                        }, {
                            "list-item": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_config_details', params: { name: props.item.id } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(props.item.topic), 513), [
                                            [_vShow, props.item.topic]
                                        ]),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_2, [
                                            (props.item.attributes['iconUrl'])
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                                    _createElementVNode("img", {
                                                        src: props.item.attributes['iconUrl']
                                                    }, null, 8, _hoisted_4)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(props.item.title), 1)
                                        ]),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        (props.item.attributes['status'] && props.item.attributes['status'] !== 'ok')
                                            ? (_openBlock(), _createBlock(_component_badge, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.item.attributes['statusMessage']), 1)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]),
                            _: 1
                        }, 8, ["title", "search-request", "grid", "source"]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createVNode(_component_router_view, {
                            onClose: closeView,
                            onNext: nextItem,
                            onPrev: prevItem
                        })
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
